export const GET_TOURNAMENT_OVERVIEW = "GET_TOURNAMENT_OVERVIEW";
export const GET_TOURNAMENT_RULES = "GET_TOURNAMENT_RULES";
export const GET_TOURNAMENT_FIXTURES = "GET_TOURNAMENT_FIXTURES";
export const GET_TOURNAMENT_ENTRIES = "GET_TOURNAMENT_ENTRIES";
export const GET_TOURNAMENT_PRIZES = "GET_TOURNAMENT_PRIZES";
export const CLEAR_FIXTURES = "CLEAR_FIXTURES";